import { Routes } from '@angular/router';

export const stocksChildRoutes: Routes = [
  { path: '', redirectTo: 'addtrx', pathMatch: 'full' },
  {
    path: ':tabId',
    children: [
      {
        path: ':tabName',
        loadComponent: () =>
          import('./addstock/addstock.component').then(
            (m) => m.AddstockComponent
          ),
      },
      {
        path: '',
        loadComponent: () =>
          import('./addstock/addstock.component').then(
            (m) => m.AddstockComponent
          ),
      },
    ],
  },

  { path: '**', redirectTo: 'addtrx', pathMatch: 'full' },
];
